import {
  AdviserData,
  FormData,
  AdviserDataToBackend,
} from 'components/AdviserDetails/interface/AdviserDetailsInterface';
import { mapOldAddressToNewAddress, formatFullAddress } from 'utils/address/index';

export const initialData: FormData = {
  email: '',
  fca: {
    number: '',
  },
  firm_name: '',
  first_name: '',
  fullName: '',
  id: '',
  last_name: '',
  fullAddress: '',
  address: {
    postcode: '',
    flatNumber: '',
    buildingName: '',
    buildingNumber: '',
    street: '',
    city: '',
    county: '',
  },
  edit: {
    address: false,
    email: false,
    contactNumber: false,
  },
  phone: '',
  fcaStatus: '',
  lmcStatus: '',
  is_active: null,
};

export const mapAdviserDataFromBackend = (data: AdviserData) => {
  const { first_name, last_name, fca, is_active, address } = data;
  const mappedAddress = mapOldAddressToNewAddress(address);

  return {
    ...data,
    address: mappedAddress,
    fullName: `${first_name} ${last_name}`,
    edit: {
      address: false,
      email: false,
      contactNumber: false,
    },
    fullAddress: formatFullAddress(mappedAddress),
    fcaStatus: fca.is_active ? 'Active' : 'Inactive',
    lmcStatus: is_active ? 'Active' : 'Inactive',
  };
};

export const mapAdviserDataToBackend = (data: FormData): AdviserDataToBackend => {
  const { email, address, phone } = data;

  return {
    email,
    address: {
      house_number: address.buildingNumber,
      street_line_1: address.buildingName || '',
      street_line_2: address.street || '',
      city: address.city,
      county: address.county || '',
      post_code: address.postcode,
    },
    phone,
  };
};
